import styled from '@emotion/styled';
import { ReactNode } from 'react';

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    flex-direction: column;
    flex: 1;
`;

interface Props {
    children: ReactNode;
}

export default function NewStepsContainer({ children }: Props) {
    return (
        <Container>
            <>{children}</>
        </Container>
    );
}
